import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    userId = '',
    roles = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.roles.grantRoles, {
        userId,
        roles,
    }, options);
    if (error) return { error, status };
    return content || {};
};

